module.exports = __webpack_public_path__ + "img/get-coupon-btn-bf-disabled.c8e066c7.png";